export default "__VITE_ASSET__B95OnsjA__"